'use client';
import Lottie from 'lottie-react';
import Loader from './assets/DotLoader.json';
import DarkLoader from './assets/RetrofitDarkLoader.json';
import DarkSALoader from './assets/LoaderDark.json';

export function DotLoader({ variant, retro = true }: { variant?: 'text' | 'outlined' | 'contained'; retro?: boolean }) {
  return (
    <Lottie
      animationData={variant == 'outlined' ? (retro ? DarkLoader : DarkSALoader) : Loader}
      loop={true}
      style={{ width: '50px', paddingTop: '5px' }}
    />
  );
}
